import { Component, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatTableDataSource } from '@angular/material/table';
import { ChartOptions } from 'chart.js';
import * as fileSaver from 'file-saver';
import { appConstants } from '../helpers/constants';
import { StandardApiRequest, Carrier, Account, RefundTotalByDisputeType, PerformanceByService, TrackingException, UserInfo, SurchargeTotal } from '../helpers/interfaces';
import { ApiService } from '../services/api.service.service';
import { SessionService } from '../services/session.service';
import { UserService } from '../services/user.service';

@Component({
  selector: 'app-tracking-exceptions-chart',
  templateUrl: './tracking-exceptions-chart.component.html',
  styleUrls: ['./tracking-exceptions-chart.component.css']
})
export class TrackingExceptionsChartComponent implements OnInit {

  constructor(private apiService: ApiService,  private notification: MatSnackBar, private sessionService: SessionService, private userService: UserService) { }

  displayedColumns: string[] = ['month', 'year'];
  dataTable: MatTableDataSource<TrackingException> = new MatTableDataSource();
  
  userInfo!: UserInfo;
  dateToday: Date = new Date();
  form: StandardApiRequest = {
    StartDate: new Date(this.dateToday.getFullYear(), 1, 1),
    EndDate: new Date(this.dateToday),
    CarrierId: 0,
    AccountId: 0,
    ClientId: 0,
    IsPageLoad: false
  }

  defaultScale = appConstants.fun.getChartScale('Month', 'Amount in Dollars');

  
  trackingException: any = {
    option: {
      scaleShowVerticalLines: false,
      responsive: true,
      isLoading: true,
      scales: {
        xAxes: [{
          ticks: {
            beginAtZero: true
          },
          scaleLabel: {
            display: true,
            labelString: 'Total Shipments'
          }
        }]
      }
    },
    label: null,
    type: appConstants.CHARTS.TYPES.HORIZONTAL_BAR,
    legend: false,
    data: [{ data: [] }]
  };

  public trackingExceptionChartColors: Array<any> = [{}];
  trackingExceptionsLoading: boolean = true;

  Carriers: Carrier[] = [{ CarrierId: 0, CarrierName: "All" }]
  Accounts: Account[] = [{ AccountId: 0, AccountNumber: "All" }]

  ngOnInit(): void {
    this.userInfo = this.userService.userInfo;
    this.sessionService.performanceForm.ClientId = this.userInfo.ClientId;
    this.form = this.sessionService.performanceForm;
    
    this.apiService.makeStandardApiCall('user/GetCarriersByClient', this.form).subscribe(
      (data: any) => {
        if (data.StatusCode != 401) {
          const carriers: Carrier[] = JSON.parse(data.Value);
          this.Carriers = [];
          this.Carriers.push({ CarrierName: 'All', CarrierId: 0 });
          carriers.forEach(element => {
            this.Carriers.push(element);
          });
        }
      }
    );
    this.updateDashboardComponents();
    this.updateAccountsList();
  }

  updateAccountsList(): void {
    this.apiService.makeStandardApiCall('user/GetAccountsByClientCarrier', this.form).subscribe(
      (data: any) => {
        if (data.StatusCode != 401) {
          const accounts: Account[] = JSON.parse(data.Value);
          this.Accounts = [];
          this.Accounts.push({ AccountNumber: 'All', AccountId: 0 });
          accounts.forEach(element => {
            this.Accounts.push({ AccountNumber: element.AccountNumber.trim().toUpperCase(), AccountId: element.AccountId });
          });
        }
      }
    );
  }

  updateDashboardComponents(): void {
    this.sessionService.performanceForm = this.form;
    
    this.trackingExceptionsLoading = true;
    this.apiService.makeStandardApiCall('values/GetTrackingException', this.form).subscribe(
      (data: any) => {
        const labelsTemp: Array<string> = [];
        const valuesTemp: Array<number> = [];
        const returnData: Array<TrackingException> = JSON.parse(data.Value);

        this.dataTable = new MatTableDataSource<TrackingException>(JSON.parse(data.Value));

        // Populate
        returnData.forEach(element => {
          labelsTemp.push(element.ScanCodeReason.trim());
					valuesTemp.push(element.ExceptionCount);
        });


        // Set values to chart
        this.trackingException.label = labelsTemp;
        this.trackingException.data[0].data = valuesTemp;
        this.trackingException.isLoading = false;
        this.trackingExceptionChartColors = [
          {
            backgroundColor: 'rgb(102,163,255,1)',
          }
         ];
        this.trackingExceptionsLoading = false;
      }
    );
  }

  downloadSearch(): void {
    this.apiService.downloadFile('GetTrackingExceptionsDownload', this.form).subscribe((response: any) => { //when you use stricter type checking
      let blob: any = new Blob([response], { type: 'application/octet-stream' });
      const url = window.URL.createObjectURL(blob);
      fileSaver.saveAs(blob, 'TrackingExceptions.xlsx');
    }), (error: any) => 
      () => this.notification.open('File downloaded successfully');
  }
}
